export default {
  cinema_referral: "推广赚钱",
  cinema_referralDesc: "分享专属链接，邀请好友注册并获得奖励",
  cinema_referralLinkTitle: "我的推广链接",
  cinema_referralLinkDesc: "好友通过此链接注册后，将自动绑定邀请关系",
  cinema_referralRulesTitle: "推广规则说明",
  cinema_referralRulesCoins: "好友通过专属链接注册后，您可获得金币奖励。金币仅用于站内看片消费，不能兑换现金或申请提现。",
  cinema_referralRulesCommission: "好友充值后，您可按规则获得充值分成。仅充值分成可提现，累计达到 ¥100 后可申请通过 USDT 提现。",
  cinema_copyLink: "复制链接",
  cinema_inviteCodeLabel: "分享码",
  cinema_inviteRuleTitle: "邀请奖励",
  cinema_inviteRuleNormal: "普通会员每成功邀请一位好友注册，可获得 20 金币，奖励自动计入金币流水。",
  cinema_distributorOverview: "分销概览",
  cinema_availableCommission: "可提现佣金",
  cinema_totalCommission: "累计佣金",
  cinema_pendingWithdrawal: "待处理提现",
  cinema_withdrawnAmount: "累计已提现",
  cinema_firstLevelRate: "一级分成",
  cinema_secondLevelRate: "二级分成",
  cinema_todayBrowse: "浏览",
  cinema_todayRegister: "注册",
  cinema_todayRecharge: "充值笔数",
  cinema_todayRechargeAmount: "充值金额",
  cinema_commissionAmount: "佣金",
  cinema_registerDetails: "注册明细",
  cinema_rechargeDetails: "充值明细",
  cinema_inviteRewards: "邀请奖励流水",
  cinema_goWithdraw: "申请提现",
  cinema_noReferralData: "暂无推广数据",
  cinema_referralLoadFailed: "推广数据加载失败，请稍后重试",
  cinema_loginToPromote: "登录后生成你的专属推广链接",
  cinema_totalEarnings: "累计收益",
  cinema_withdrawable: "可提现",
  cinema_frozen: "冻结中",
  cinema_invitedCount: "邀请人数",
  cinema_coinUnit: "金币",
  cinema_people: "人",
  cinema_conversionStats: "推广转化统计",
  cinema_allDatesTotal: "全部日期合计",
  cinema_selectedDatesTotal: "所选日期合计",
  cinema_conversionStatsDesc: "按天查看浏览、注册、充值和实际分成",
  cinema_colDate: "日期",
  cinema_colPv: "浏览人数",
  cinema_colBrowseCount: "浏览次数",
  cinema_colRegister: "注册",
  cinema_colRechargeUsers: "充值人数",
  cinema_colRechargeOrders: "充值订单",
  cinema_colPaidAmount: "实付金额",
  cinema_colCommission: "实际分成",
  cinema_colRegisterRate: "注册率",
  cinema_colRechargeRate: "充值率",
  cinema_commissionRateTitle: "佣金比例",
  cinema_currentRateLabel: "当前实际佣金分成比例",
  cinema_baseRate: "基础比例",
  cinema_currentRate: "当前比例",
  cinema_earningsRecord: "收益记录",
  cinema_inviteDetail: "邀请明细",
  cinema_allEarnings: "全部收益记录",
  cinema_filterAll: "全部",
  cinema_filterPending: "待结算",
  cinema_filterSettled: "已结算",
  cinema_earningsDate: "时间",
  cinema_earningsType: "类型",
  cinema_earningsUser: "用户",
  cinema_earningsAmount: "收益",
  cinema_earningsStatus: "状态",
  cinema_statusSettled: "已结算",
  cinema_statusPending: "待结算",
  cinema_noEarningsRecords: "暂无相关记录",
  cinema_referralUser: "用户",
  cinema_referralRegDate: "注册时间",
  cinema_referralRecharged: "累计充值",
  cinema_referralEarned: "我的收益",
  cinema_startDate: "开始日期",
  cinema_endDate: "结束日期",
  cinema_query: "查询",
  cinema_dateRangeError: "开始日期不能晚于结束日期",
  cinema_brand: "黄果TV",
  cinema_language: "语言",
  cinema_tagline: "AI原创短剧，无限精彩",
  cinema_navHome: "首页",
  cinema_navCategories: "排行榜",
  cinema_rankingTitle: "排行榜",
  cinema_rankingAll: "全部",
  cinema_rankingLoading: "榜单加载中...",
  cinema_rankingStats: "{{scope}} · {{period}} · {{count}} 部剧 · 播放 {{views}} 次",
  cinema_rankingTotal: "总排行",
  cinema_rankingMonth: "月排行",
  cinema_rankingWeek: "周排行",
  cinema_rankingLatest: "最新更新",
  cinema_rankingCreator: "投稿排行",
  cinema_creatorLabel: "用户投稿",
  cinema_rankingEmpty: "暂无上榜剧集",
  cinema_navMyList: "热播",
  cinema_soundGuideTitle: "点击这里打开声音",
  cinema_soundGuideAction: "打开声音",
  cinema_soundGuideDismiss: "关闭声音引导",
  cinema_navHistory: "历史",
  cinema_navAds: "赚币",
  cinema_adsTitle: "广告推荐",
  cinema_adsSubtitle: "发现更多精彩内容",
  cinema_adFeatured: "精选推荐",
  cinema_adOpen: "立即查看",
  cinema_adsEmpty: "暂无广告",
  cinema_adsLoadFailed: "广告加载失败，请稍后重试",
  cinema_earnTitle: "赚金币",
  cinema_earnSubtitle: "每天签到，金币轻松拿",
  cinema_earnBalance: "我的金币",
  cinema_checkInTitle: "每日签到",
  cinema_checkInSubtitle: "连续签到可领取更多金币",
  cinema_checkInDay: "第{{day}}天",
  cinema_checkInToday: "今天",
  cinema_checkInClaim: "签到领 {{points}} 金币",
  cinema_checkInClaimed: "今日已签到",
  cinema_checkInLogin: "登录后签到",
  cinema_checkInSuccess: "签到成功，获得 {{points}} 金币",
  cinema_checkInFailed: "签到失败，请检查网络后重试",
  cinema_checkInNoReward: "该设备今日签到奖励已领取",
  cinema_checkInStreak: "连续签到",
  cinema_checkInStreakValue: "{{days}} 天",
  cinema_checkInTotal: "签到累计",
  cinema_checkInTotalValue: "{{points}} 金币",
  cinema_checkInLoadFailed: "签到信息加载失败",
  cinema_retry: "重新加载",
  cinema_moreEarnWays: "更多赚币方式",
  cinema_inviteEarnTitle: "邀请好友赚金币",
  cinema_inviteEarnDesc: "好友注册成功，即可获得邀请奖励",
  cinema_goInvite: "去邀请",
  cinema_earnCoinsTitle: "赚币中心",
  cinema_earnCoinsBalance: "我的金币",
  cinema_earnCoinsSignInStreak: "您已连续签到{{count}}天",
  cinema_earnCoinsCheckIn: "签到",
  cinema_earnCoinsCheckedIn: "已签到",
  cinema_earnCoinsTomorrow: "明日再来",
  cinema_earnCoinsInviteTitle: "邀请一位好友获取",
  cinema_earnCoinsInviteCode: "我的邀请码",
  cinema_earnCoinsGoInvite: "去邀请",
  cinema_earnCoinsLimitedTask: "限时任务",
  cinema_earnCoinsTimeLeft: "倒计时",
  cinema_earnCoinsNewbieTask: "新手任务",
  cinema_earnCoinsDailyTask: "日常任务",
  cinema_earnCoinsRecommendations: "相关推荐",
  cinema_earnCoinsAdTask: "观看广告",
  cinema_earnCoinsAdTaskDesc: "完成广告任务即可获得更多金币",
  cinema_earnCoinsGoWatch: "观看广告",
  cinema_earnCoinsTaskReward: "+{{reward}}",
  cinema_earnCoinsDayLabel: "第{{day}}天",
  cinema_earnCoinsToday: "今天",
  cinema_earnCoinsCoinUnit: "金币",
  cinema_earnCoinsAdCurrent: "当前任务",
  cinema_earnCoinsAdLocked: "待解锁任务",
  cinema_earnCoinsTaskCompleted: "已完成",
  cinema_limitedRechargeTaskTitle: "限时完成首充",
  cinema_limitedRechargeTaskAction: "去充值",
  cinema_claimReward: "领取",
  cinema_claiming: "领取中",
  cinema_taskClaimFailed: "领取失败，请稍后重试",
  cinema_bindEmailAction: "去绑定",
  cinema_limitedRechargeTaskExpired: "已过期",
  cinema_watchHistory: "观看历史",
  cinema_navSearch: "搜索剧集...",
  cinema_login: "登录",
  cinema_navProfile: "我的",
  cinema_vip: "会员",
  cinema_heroPlay: "立即播放",
  cinema_heroMore: "了解更多",
  cinema_hotRecommend: "热门推荐",
  cinema_carouselLoading: "轮播内容加载中...",
  cinema_newRelease: "新剧上线",
  cinema_allSeries: "全部剧集",
  cinema_viewAll: "查看全部",
  cinema_episodes: "共 {{count}} 集",
  cinema_rating: "{{score}} 分",
  cinema_views: "{{count}} 次观看",
  cinema_play: "播放",
  cinema_continueWatch: "继续观看",
  cinema_rewatch: "重新观看",
  cinema_categoryAll: "全部",
  cinema_categoryUrban: "都市情感",
  cinema_categorySuspense: "悬疑探案",
  cinema_categoryCostume: "古装穿越",
  cinema_categoryWorkplace: "职场逆袭",
  cinema_categorySciFi: "科幻冒险",
  cinema_categorySciFiRomance: "科幻爱情",
  cinema_unlock: "解锁剧集",
  cinema_unlockDesc: "解锁本集需要消耗 {{cost}} 金币",
  cinema_unlockConfirm: "确认解锁并播放",
  cinema_cancel: "取消",
  cinema_balance: "当前余额：{{coins}} 金币",
  cinema_insufficient: "金币不足，请先充值",
  cinema_unlocked: "已解锁",
  cinema_locked: "未解锁",
  cinema_episodeNumber: "第 {{number}} 集",
  cinema_playing: "播放中",
  cinema_backToList: "返回列表",
  cinema_back: "返回",
  cinema_noSeries: "暂无剧集",
  cinema_seriesDesc: "剧情介绍",
  cinema_episodeList: "选集",
  cinema_nextEpisode: "下一集",
  cinema_episodeEnded: "本集已播放完毕",
  cinema_nextEpisodePrompt: "是否继续播放第 {{number}} 集？",
  cinema_playNextEpisode: "播放下一集",
  cinema_prevEpisode: "上一集",
  cinema_freeLabel: "免费",
  cinema_vipLabel: "VIP",
  cinema_newLabel: "新剧",
  cinema_hotLabel: "热门",
  cinema_featuredBanner: "本周必看",
  cinema_watchNow: "立即观看",
  cinema_searchPlaceholder: "搜索你感兴趣的剧集...",
  cinema_noResults: "未找到相关剧集",
  cinema_emptyMyList: "还没有热播内容，去首页看看吧",
  cinema_emptyHistory: "还没有观看记录",
  cinema_addToMyList: "加入片单",
  cinema_removeFromMyList: "移出片单",
  cinema_clearAll: "清空全部",
  cinema_footerCopy: "黄果TV — 精品短剧平台",
  cinema_footerWarning: "本平台内容由AI生成，仅供娱乐。请遵守当地法律法规。",
  cinema_myList: "热播剧场",
  cinema_addedAt: "{{date}}添加",
  cinema_expand: "展开",
  cinema_collapse: "收起",
  cinema_historyAll: "全部",
  cinema_historyUnfinished: "未看完",
  cinema_historyFinished: "已看完",
  cinema_historyCount: "共 {{count}} 条记录",
  cinema_noHistoryFilter: "该分类下暂无记录",
  cinema_finished: "已看完",
  cinema_watchedFull: "已全部看完",
  cinema_welcomeBack: "欢迎回来",
  cinema_loginDesc: "登录后解锁更多精彩内容",
  cinema_phoneLogin: "手机号登录",
  cinema_emailLogin: "邮箱登录",
  cinema_phonePlaceholder: "请输入手机号",
  cinema_emailPlaceholder: "请输入邮箱地址",
  cinema_agreeTerms: "登录即表示同意",
  cinema_userAgreement: "《用户协议》",
  cinema_privacyPolicy: "《隐私政策》",
  cinema_getCode: "获取验证码",
  cinema_loginNow: "立即登录",
  cinema_otherLogin: "其他登录方式",
  cinema_loggingIn: "登录中...",
  cinema_loginSuccess: "登录成功",
  cinema_loginRedirect: "即将跳转至个人中心...",
  cinema_profile: "个人中心",
  cinema_memberLabel: "会员",
  cinema_dealerLabel: "分销商",
  cinema_coinAmount: "{{count}} 金币",
  cinema_profileAccount: "账户管理",
  cinema_profileContent: "内容管理",
  cinema_profileSettings: "设置",
  cinema_editProfile: "编辑资料",
  cinema_myCoins: "我的金币",
  cinema_myPurchases: "已购剧集",
  cinema_downloads: "离线下载",
  cinema_playbackSettings: "播放设置",
  cinema_notifications: "消息通知",
  cinema_cacheManage: "缓存管理",
  cinema_about: "联系我们",
  cinema_contactUnavailable: "在线客服暂不可用，请稍后再试",
  cinema_watchedHours: "观看时长(小时)",
  cinema_collectionCount: "收藏剧集",
  cinema_logout: "退出登录",
  cinema_logoutConfirm: "确认退出？",
  cinema_logoutConfirmDesc: "退出后需要重新登录才能使用完整功能",
  cinema_version: "版本 {{version}}",
  cinema_rechargeTitle: "金币充值",
  cinema_rechargeSubtitle: "请选择充值套餐",
  cinema_rechargeVpnWarning: "VPN 或代理网络可能触发支付风控，导致收银台无法打开或支付失败。",
  cinema_rechargeVpnGuideTitle: "支付前请先关闭 VPN",
  cinema_rechargeVpnInstruction: "关闭 VPN 后，再点击下方按钮继续使用已选择的支付通道。",
  cinema_rechargeVpnContinue: "我已关闭 VPN，继续支付",
  cinema_rechargeRMB: "人民币充值",
  cinema_rechargeUSDT: "USDT 充值",
  cinema_rechargeRecommended: "推荐",
  cinema_rechargeCoins: "金币",
  cinema_rechargeBonus: "+{{points}}金币",
  cinema_rechargeCredited: "到账 {{points}}",
  cinema_firstRechargeBannerTitle: "首充福利！首次充值任意金额额外加赠",
  cinema_firstRechargeSelectedBonus: "本次加赠 {{points}} 金币",
  cinema_firstRechargeLimitedTitle: "限时首充福利",
  cinema_dailyRechargeLimitedTitle: "限时充值福利",
  cinema_firstRechargeLimitedBonus: "任意金额额外加赠 {{percent}}%",
  cinema_rechargePayMethod: "支付方式",
  cinema_rechargePay: "支付",
  cinema_rechargeNoPackages: "暂未配置可用套餐",
  cinema_paymentUnavailable: "支付暂不可用，请联系管理员",
  cinema_follow: "关注",
  cinema_collect: "收藏",
  cinema_share: "分享",
  cinema_loading: "加载中...",
  cinema_favorites: "我的收藏",
  cinema_emptyFavorites: "还没有收藏剧集",
  cinema_emptyPurchases: "还没有已购剧集",
  cinema_clearAllConfirm: "确认清空全部观看记录吗？",
  cinema_episodesUnit: "集",
  cinema_lastWatched: "上次观看第 {{episode}} 集",
  cinema_purchasedEpisodes: "已解锁 {{count}} 集",
  cinema_account: "账户信息",
  cinema_accountName: "昵称",
  cinema_accountEmail: "邮箱",
  cinema_shareCode: "分享码",
  cinema_saveProfile: "保存资料",
  cinema_profileSaved: "资料已保存",
  cinema_profileSaveFailed: "保存资料失败",
  cinema_accountInfo: "基本资料",
  cinema_changePassword: "修改密码",
  cinema_newPassword: "新密码",
  cinema_confirmPassword: "确认新密码",
  cinema_passwordHint: "密码至少需要6位",
  cinema_passwordMismatch: "两次输入的密码不一致",
  cinema_passwordSaved: "密码修改成功",
  cinema_passwordSaveFailed: "密码修改失败",
  cinema_savePassword: "保存新密码",
  cinema_pointsBalance: "当前金币",
  cinema_coinLedger: "金币流水",
  cinema_businessReference: "业务关联",
  cinema_emptyPointLogs: "还没有金币流水",
  cinema_pointLog_registerReward: "注册奖励",
  cinema_pointLog_appFirstLoginReward: "APP首次登录奖励",
  cinema_pointLog_inviteReward: "邀请奖励",
  cinema_pointLog_dailyCheckIn: "每日签到奖励",
  cinema_pointLog_limitedRechargeTask: "限时首充任务奖励",
  cinema_pointLog_emailBindingTask: "绑定邮箱任务奖励",
  cinema_pointLog_dailyUnlockTask: "每日解锁任务奖励",
  cinema_bindEmailTaskTitle: "绑定邮箱",
  cinema_dailyUnlockTaskTitle: "解锁{{count}}集新剧集",
  cinema_unlockAction: "去解锁",
  cinema_dailyTaskProgress: "今日进度 {{current}}/{{target}}（第1集不计）",
  cinema_pointLog_firstEpisodeUnlock: "解锁首集权益",
  cinema_pointLog_episodeUnlock: "解锁剧集",
  cinema_pointLog_recharge: "充值到账",
  cinema_pointLog_firstRechargeBonus: "首充福利加赠",
  cinema_pointLog_dailyRechargeBonus: "限时充值福利加赠",
  cinema_pointLog_adminAdjust: "后台调整",
  cinema_pointLog_other: "金币变动",
  cinema_pointBiz_register: "用户注册",
  cinema_pointBiz_registerBackfill: "注册奖励补发",
  cinema_pointBiz_appFirstLogin: "APP首次登录",
  cinema_pointBiz_inviteRegister: "邀请注册",
  cinema_pointBiz_dailyCheckIn: "每日签到",
  cinema_pointBiz_legacyLimitedRechargeTask: "24小时充值任务",
  cinema_pointBiz_limitedRechargeTask: "1小时首充任务",
  cinema_pointBiz_emailBindingTask: "绑定邮箱任务",
  cinema_pointBiz_unlockThreeEpisodes: "每日解锁3集任务",
  cinema_pointBiz_unlockFiveEpisodes: "每日解锁5集任务",
  cinema_pointBiz_episodeUnlock: "剧集解锁",
  cinema_pointBiz_rechargeOrder: "充值订单",
  cinema_pointBiz_adminAdjust: "后台调整",
  cinema_pointBiz_other: "其他业务",
  cinema_playbackAutoplay: "自动播放下一集",
  cinema_playbackAutoplayDesc: "当前剧集播放完成后自动进入下一集",
  cinema_aboutDesc: "黄果TV为你提供持续更新的短剧内容。",
  cinema_rechargeOrders: "充值流水",
  cinema_myRechargeRecords: "查看我的充值记录",
  cinema_totalInvites: "累计邀请",
  cinema_distributionStats: "推广统计",
  cinema_distributionStatsDesc: "按时间查看浏览、注册、充值与佣金数据",
  cinema_summaryDate: "日期",
  cinema_summaryBrowse: "浏览",
  cinema_summaryRegister: "注册",
  cinema_summaryRechargeCount: "充值笔数",
  cinema_conversionRate: "注册转化率",
  cinema_commissionRatio: "佣金比例",
  cinema_browseDetails: "浏览明细",
  cinema_browseTime: "浏览时间",
  cinema_browseDrama: "浏览影片",
  cinema_browseRegion: "地区",
  cinema_noBrowseData: "还没有浏览记录",
  cinema_noSummaryData: "还没有汇总数据",
  cinema_rewarded: "已奖励",
  cinema_registered: "已注册",
  cinema_close: "关闭",
  cinema_emptyRechargeOrders: "还没有充值记录",
  cinema_rechargeRecords: "充值流水",
  cinema_commissionRecords: "分成流水",
  cinema_rechargeTime: "充值时间",
  cinema_paymentMethod: "支付方式",
  cinema_paymentStatus: "支付状态",
  cinema_orderNo: "订单号",
  cinema_noRechargeRecords: "还没有充值流水",
  cinema_commissionTime: "分成时间",
  cinema_commissionLevel: "分成层级",
  cinema_commissionRate: "分成比例",
  cinema_noCommissionRecords: "还没有分成流水",
  cinema_search: "查询",
  cinema_reset: "重置",
  cinema_previousPage: "上一页",
  cinema_nextPage: "下一页",
  cinema_paymentStatus_created: "已创建",
  cinema_paymentStatus_pending: "待支付",
  cinema_paymentStatus_paid: "充值成功",
  cinema_paymentStatus_failed: "支付失败",
  cinema_paymentStatus_closed: "已关闭",
  cinema_paymentStatus_expired: "已过期",
  cinema_paymentAwaiting: "订单已创建，请在支付页面完成支付。如果失败，请检查是否关闭 VPN",
  cinema_usdtAddress: "收款地址",
  cinema_usdtNetwork: "仅支持 TRC20 网络",
  cinema_copy: "复制",
  cinema_copied: "已复制",
  cinema_playerSettings: "播放设置",
  cinema_playerQuality: "清晰度",
  cinema_playerSpeed: "播放速度",
  cinema_playerAuto: "自动",
  cinema_playerSource: "原画",
  cinema_playerSubtitles: "字幕",
  cinema_subtitleAuto: "自动字幕",
  cinema_subtitleOff: "关闭字幕",
  cinema_appDownloadTitle: "下一集用 App 看更稳",
  cinema_appDownloadDesc: "自动记住进度，更新时提醒你回来。",
  cinema_appDownloadReward: "下载 APP，首次登录额外赠送 {{points}} 金币！",
  cinema_homeAppDownloadReward: "App首登送{{points}}金币！",
  cinema_shareEarnPoints: "分享得金币",
  cinema_shareLinkLabel: "分享链接",
  cinema_shareRewardUnlimited: "每分享一名用户加入，你将获取 {{points}} 金币，分享无上限！",
  cinema_loginForShareLink: "登录并获取分享链接",
  cinema_viewReferralStats: "查看推广情况",
  cinema_episodeFinished: "本集播放完毕",
  cinema_unlockNextEpisode: "解锁下一集",
  cinema_changeDrama: "更换影片",
  cinema_allUnlocked: "已全部解锁",
  cinema_appDownloadButton: "下载 App",
  cinema_appDownloadUnavailable: "暂未提供下载地址",
  cinema_rechargeAppPromptTitle: "下载 App 领金币",
  cinema_rechargeAppPromptReward: "下载 App 并登录，额外赠送 {{points}} 金币！",
  cinema_rechargeAppPromptDesc: "使用 App 观看更稳定，还能自动保存观看进度。",
  cinema_appDownloadQr: "扫码下载 App",
  cinema_ageGateBadge: "年龄验证",
  cinema_ageGateTitle: "成人内容提示",
  cinema_ageGateDescription: "本网站包含仅适合成年人的 AI 生成虚构内容。继续访问即表示您确认已年满 18 周岁，并同意遵守所在地法律法规。",
  cinema_ageGateUnderage: "未满 18 周岁请立即离开。",
  cinema_ageGateConfirm: "我已年满 18 周岁，进入网站",
  cinema_creatorCenter: "创作者中心",
  cinema_creatorCenterDesc: "把你的故事搬上黄果TV，作品通过审核后将在影城上架，让千万观众看到你的才华，并享受高额度订阅分成。",
  cinema_creatorCenterNote: "注：非原创作品必须无水印",
  cinema_creatorMemberReady: "您已是会员，可一键申请入驻",
  cinema_creatorBecome: "成为一名创作者",
  cinema_creatorGateDesc: "把你的故事搬上黄果TV，作品通过审核后将在影城上架，让千万观众看到你的才华，并享受高额度订阅分成。",
  cinema_creatorApplyBtn: "立即申请成为创作者",
  cinema_creatorBenefitTitle: "创作者权益",
  cinema_creatorBenefit1: "作品上架影城，并带有专属「原创」标签",
  cinema_creatorBenefit2: "实时查看作品展示量、订阅量与收益分成",
  cinema_creatorBenefit3: "解锁更多创作工具与推广资源，更快变现",
  cinema_creatorReviewTip: "申请与作品均经平台审核，内容需符合社区规范。",
  cinema_creatorLevel: "认证创作者",
  cinema_creatorOriginal: "原创",
  cinema_creatorSince: "入驻于",
  cinema_creatorAddWork: "上传新作品",
  cinema_creatorTabOverview: "数据总览",
  cinema_creatorTabWorks: "我的作品",
  cinema_creatorTabUpload: "上传作品",
  cinema_creatorTabPlatform: "创作平台",
  cinema_creatorSubmitted: "提交成功，正在等待平台审核",
  cinema_creatorStatViews: "总展示量",
  cinema_creatorStatSubs: "总订阅量",
  cinema_creatorStatRevenue: "累计分成",
  cinema_creatorStatWithdraw: "可提现",
  cinema_creatorStatWorks: "作品总数",
  cinema_creatorStatReview: "审核中",
  cinema_creatorStatRejected: "未通过",
  cinema_creatorTopWork: "表现最佳的作品",
  cinema_creatorViews: "展示量",
  cinema_creatorSubscriptions: "订阅量",
  cinema_creatorShare: "分成",
  cinema_creatorNoPublished: "还没有已上架的作品",
  cinema_creatorFilterPublished: "已上架",
  cinema_creatorFilterReview: "审核中",
  cinema_creatorFilterRejected: "未通过",
  cinema_creatorWorksTitle: "我的作品",
  cinema_creatorNoWorks: "还没有作品，快去上传第一部吧",
  cinema_creatorGoUpload: "去上传",
  cinema_creatorStatusPublished: "已上架",
  cinema_creatorStatusReview: "审核中",
  cinema_creatorStatusApproved: "等待转码",
  cinema_creatorStatusTranscoding: "转码中",
  cinema_creatorStatusReady: "等待发布",
  cinema_creatorStatusTranscodeFailed: "转码失败",
  cinema_creatorStatusPublishFailed: "发布失败",
  cinema_creatorStatusRejected: "未通过",
  cinema_creatorPublishedOn: "上架于",
  cinema_creatorSubmittedOn: "提交于",
  cinema_creatorRejectedTip: "未通过 · 提交于",
  cinema_creatorWorkName: "作品名称",
  cinema_creatorWorkNamePh: "请输入作品名称",
  cinema_creatorCategory: "题材分类",
  cinema_creatorCover: "作品封面",
  cinema_creatorCoverHint: "请上传一张竖版作品封面",
  cinema_creatorCoverUrlPh: "粘贴图片链接（可选）",
  cinema_creatorSynopsis: "剧情简介",
  cinema_creatorSynopsisPh: "用一两句话介绍你的故事，让观众一眼看懂…",
  cinema_creatorEpisodeTitle: "剧集信息",
  cinema_creatorEpisodeDesc: "每一集都要填写标题，并分别上传一个 MP4 视频",
  cinema_creatorEpisodeTitlePh: "本集标题",
  cinema_creatorEpisodeDurPh: "时长(分)",
  cinema_creatorAddEpisode: "添加剧集",
  cinema_creatorEpShort: "第{{count}}集",
  cinema_creatorEpisodeUpload: "上传 MP4",
  cinema_creatorEpisodeUploading: "上传中…",
  cinema_creatorEpisodeReplace: "替换视频",
  cinema_creatorEpisodeMp4Only: "仅支持 .mp4 文件，单个文件最大 100MB",
  cinema_creatorEpisodeTypeError: "每一集只能上传 .mp4 视频",
  cinema_creatorEpisodeSizeError: "单个剧集视频不能超过 100MB",
  cinema_creatorEpisodeUploadFailed: "剧集视频上传失败，请稍后重试",
  cinema_creatorEpisodeRequired: "请填写每一集标题并上传对应的 MP4 视频",
  cinema_creatorRequired: "请填写作品名称并选择封面后再提交",
  cinema_creatorWorkNameRequired: "请填写作品名称",
  cinema_creatorCategoryRequired: "请选择题材分类",
  cinema_creatorCoverRequired: "请上传作品封面",
  cinema_creatorEpisodeTitleRequired: "请填写本集标题",
  cinema_creatorEpisodeVideoRequired: "请上传本集 MP4 视频",
  cinema_creatorSubmit: "提交审核",
  cinema_creatorPlatformTag: "创作者推荐",
  cinema_creatorPlatformTitle: "创作工具平台",
  cinema_creatorPlatformDesc: "前往官方创作平台，使用更多专业创作工具、剧本灵感与素材库，让好故事更快成型并一键投稿。",
  cinema_creatorPlatformPoint1: "AI 剧本与灵感",
  cinema_creatorPlatformPoint2: "专业创作与上传工具",
  cinema_creatorPlatformPoint3: "流量扶持与收益结算",
  cinema_creatorPlatformOpen: "前往创作平台",
  cinema_creatorEarnBannerTitle: "把你的故事搬上影城",
  cinema_creatorEarnBannerDesc: "成为创作者，上传作品，赚取丰厚的现金分成收益！",
  cinema_creatorEarnBannerBtn: "进入创作者中心",
  cinema_creatorApplyFailed: "申请失败，请稍后重试",
  cinema_creatorSubmitFailed: "提交失败，请稍后重试",
  cinema_creatorSubmitting: "提交中…",
  cinema_creatorCategoryEmpty: "暂无可用分类",
  cinema_creatorCoverUpload: "上传封面",
  cinema_creatorCoverUploading: "上传中…",
  cinema_creatorCoverChoose: "选择图片",
  cinema_creatorCoverReplace: "替换图片",
  cinema_creatorCoverRemove: "移除",
  cinema_creatorCoverFormat: "支持 JPG、PNG、WebP、GIF，最大 10MB，只能上传一张。",
  cinema_creatorCoverTypeError: "请选择 JPG、PNG、WebP 或 GIF 图片",
  cinema_creatorCoverSizeError: "封面图片不能超过 10MB",
  cinema_creatorCoverUploadFailed: "封面上传失败，请稍后重试",
  cinema_creatorUploadNoticeTitle: "作品上传说明",
  cinema_creatorUploadNotice1: "上传资源无论是否原创，必须是AI类作品且无水印。",
  cinema_creatorUploadNotice2: "原创作品相对转发作品分成更高。",
  cinema_creatorUploadNotice3: "剧集价格由平台评级并最终决定！",
  cinema_creatorUploadNotice4: "单集时长不得少于150秒。",
  cinema_creatorUploadNoticeConfirm: "我已了解，继续上传",
};
